import { registerViewMount } from './navigation.js';
import { appendTrustedAdminViewFragment } from './trusted-admin-view-fragment.js';

let videoManagerMountPromise = null;

export function initVideoManagerViewFragment({ onMounted } = {}) {
  registerViewMount('video-manager', () => mountVideoManagerView(onMounted));
}

async function mountVideoManagerView(onMounted) {
  if (document.getElementById('view-video-manager')) return;
  if (videoManagerMountPromise) return videoManagerMountPromise;

  videoManagerMountPromise = (async () => {
    const host = document.getElementById('admin-lazy-view-host');
    if (!host) throw new Error('Admin lazy view host is unavailable');
    await appendTrustedAdminViewFragment(host, '/admin-views/video-manager.html', 'Unable to load video manager view');
    onMounted?.();
  })();

  try {
    await videoManagerMountPromise;
  } catch (error) {
    videoManagerMountPromise = null;
    throw error;
  }
}
